// /src/App.jsx

import { Outlet } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { useAuth } from "./authContext";
import { WebsiteAccessGateProvider } from "./hooks/useWebsiteAccessGate";
import Header from "./components/Header";
import LogoutHandler from "./components/LogoutHandler";
import AdminLockEnforcer from "./components/AdminLockEnforcer";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import HexagonBackground from "../utils/HexagonBackground";
import LaserHit from "../utils/LaserHit";

export default function App() {
  const { isLoggedIn } = useAuth();

  return (
    <>
      <ScrollToTop />
      <CookieBanner />
      <div className={isLoggedIn ? "App loggedIn" : "App"}>
        <HexagonBackground>
          <LaserHit />
        </HexagonBackground>

        <WebsiteAccessGateProvider>
          <Header />
          <LogoutHandler />
          <AdminLockEnforcer />
          <div className={isLoggedIn ? "content-container isLoggedIn" : "content-container isNotLoggedIn"}>
            <Outlet />
          </div>
        </WebsiteAccessGateProvider>

        <Footer />
      </div>
    </>
  );
}
